<template>
  <div>
    <v-row dense>
      <v-col cols="12">
        <v-text-field
          dense
          outlined
          hide-details
          autocomplete="off"
          class="rounded-tag-small"
          label="Chave de acesso"
          v-mask="['############################################']"
          :error="$v.notaFiscalManual.chaveAcesso.$error"
          @blur="$v.notaFiscalManual.chaveAcesso.$touch()"
          v-model="notaFiscalManual.chaveAcesso"
        >
          <template v-slot:append-outer>
            <px-anexo :max="1"
                      title="Anexo da nota fiscal"
                      empty-button-text="Anexo da nota fiscal"
                      v-model="notaFiscalManual.notaFiscalFile"
                      download-base-path="files/download-comprador"
                      @loading="onFileLoad"/>
          </template>
        </v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import validationMixin from '@/mixins/validation-mixin';

export default {
  mixins: [validationMixin],
  props: {
    compra: {
      type: Object,
      required: true,
    },
    notaFiscalManual: {
      type: Object,
      required: true,
    },
    loadingNotaFiscal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    };
  },
  methods: {
    isValid() {
      if (this.hasFileLoading) {
        this.$toast('Aguarde até o término do envio dos arquivos', { color: 'error' });
        return false;
      }
      return !this.validateForm();
    },
    onFileLoad(loading) {
      this.hasFileLoading = loading;
    },
  },
  validations: {
    notaFiscalManual: {
      chaveAcesso: {
        required(value) {
          return !!value;
        },
        length(value) {
          return value ? value.length === 44 : true;
        },
      },
    },
  },
};
</script>
